import { useQuery } from "react-query";

import { useOrg } from "@hooks/useOrg";

import { fetchRegistryUpdates } from "@pages/registry/api";

/*
 * This hook returns the list of recently changed rules
 */
export const useRegistryUpdates = () => {
  const org = useOrg();

  return useQuery(
    ["RegistryUpdates", { org }],
    () => fetchRegistryUpdates(org?.id!),
    { enabled: !!org }
  );
};
